import { UPDATE_EMPLOYEES } from '../types';

const initialState = [ ]

export default function reducerState (state = initialState, action) {
  switch(action.type) {
    case UPDATE_EMPLOYEES :
      return action.payload && action.payload.filter(e => e.nameF && e.nameL);
    default:
      return state;
  }
}
